import { AdminProfessionals } from '@platform/client';
import { AdminFormModal, ModalStage } from '../../AdminFormModal';
import { useState, useContext } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { AdminTableContext } from '../../AdminTable';

export const DisableUserModal = (props: { userId: number; onClose: () => void }) => {
  const [modalStage, setModalStage] = useState<ModalStage>('form');
  const { adminQueryOptionsV2 } = useContext(AdminTableContext);
  const queryClient = useQueryClient();
  const disableUserMutator = AdminProfessionals.useDisableProUser({
    mutation: {
      onError: () => setModalStage('error'),
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: AdminProfessionals.getGetAdminProfessionalsQueryKey({
            ...adminQueryOptionsV2,
          }),
        });
        setModalStage('success');
      },
    },
  });
  return (
    <AdminFormModal
      title='Disable User'
      modalStage={modalStage}
      onClose={props.onClose}
      submitCTA={{
        buttonVariant: 'primary-danger',
        text: 'Disable user',
        callback: () => {
          disableUserMutator.mutate({ data: { userId: props.userId } });
        },
      }}
    >
      Disable user {props.userId}?
    </AdminFormModal>
  );
};
